import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { MarketingVoucherEditExistingContainer } from "@/components/features/marketing/voucher/edit";

import { useGetVoucherEditPageParams } from "./_hooks/use-get-voucher-edit-page-params";

export const MarketingVoucherEditPage = () => {
	const { hotelID, voucherID } = useGetVoucherEditPageParams();
	const activeLangCode = LangCode.Default;
	const navigator = {
		default: generatePath(PATHS.HOTEL.MARKETING.VOUCHER.EDIT, { hotelID, voucherID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.MARKETING.VOUCHER.I18N, { hotelID, voucherID, langCode }),
	};

	return (
		<PageMeta title="宿泊券の編集" url={generatePath(PATHS.HOTEL.MARKETING.VOUCHER.EDIT, { hotelID, voucherID })}>
			<MarketingVoucherEditExistingContainer
				hotelID={hotelID}
				voucherID={voucherID}
				navigator={navigator}
				activeLangCode={activeLangCode}
			/>
		</PageMeta>
	);
};

MarketingVoucherEditPage.displayName = "MarketingVoucherEditPage";
